
  import { css } from 'lit';
  export const styles = css`[part~=input-container]{border:.0625rem solid var(--chat-input-border)}`;
  